import React, { Component } from 'react';
import Checkbox from './Checkbox';
import './Dropdown.css'

class Dropdown extends Component {

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (e) => {
        if (this.wrapperRef && !this.wrapperRef.contains(e.target) && this.props.active) {
            this.props.close(this.props.name);
        }
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    }

    handleClick = (e) => {
        e.preventDefault();
        let id = e.currentTarget.id;
        let active = this.props.list.find(s => s.id == id)
        this.props.handleChange(active, this.props.name);
    }

    render() {
        let display = ''
        if(!this.props.display && this.props.list.length) {
            display = this.props.list.find(sel => sel.id == this.props.activeId.toString()).display
        } else if(this.props.display) {
            display = this.props.display
        }
        return(
            <span className={`Dropdown ${this.props.className} ${this.props.type} ${this.props.active ? 'show' : 'hidden'}`}>

                <input name={this.props.name} className='dropdown-input' type='text' onFocus={() => this.props.open(this.props.name)} readOnly/>
                    <span className='mobileSelect-background'></span>
                    <span ref={this.setWrapperRef} className={`select-group dropdown-group ${this.props.active ? 'show' : 'hidden'}`}>
                        {this.props.label && (
                            <label htmlFor={this.props.name}>{this.props.label}</label>
                        )}
                        <div className="select select-custom dropdown-custom" onClick={() => this.props.toggle(this.props.name)}>
                                <span>
                                    {display}
                                </span>
                            </div>
                            <div className='select-dropdown'>
                                <div className="closeModal"  onClick={() => this.props.close(this.props.name)}>
                                    <div id='x-icon'>
                                        <span />
                                        <span />
                                        <span />
                                        <span />
                                    </div>
                                </div>
                                <span className='selection-name'>{this.props.selection}</span>
                                {this.props.type === 'multiple-select' ? (
                                    <ul className='Dropdown-list multiple-select'>
                                        {this.props.list.map((l,i) => 
                                        <li className={i === 0 ? 'first-select' : ''} key={i}
                                         onClick={
                                             (e) => {
                                                 e.preventDefault();
                                                 this.props.handleChange(l.id)
                                             }
                                         }
                                        >
                                            <span className='selection'>
                                                <span className='name'>
                                                    {this.props.translate || l.id === 'all' ?
                                                            l.display 
                                                            :
                                                            l.id
                                                    }
                                                </span>
                                                {this.props.explanation && l.explanation && (
                                                    <span className='explanation'>
                                                        ({l.explanation})
                                                    </span>
                                                )}
                                            </span> 
                                            <Checkbox id={i} active={this.props.activeList.indexOf(l.id) > -1} 
                                             handleChange={this.props.handleChange}/>
                                        </li>)}
                                    </ul>
                                ) : (
                                    <ul className='Dropdown-list single-select'>
                                        {this.props.list.map((l,i) => 
                                            <li className={`${(i === 0  && !this.props.activeId) || this.props.activeId === l.id ? 'active' : ''}`}
                                                onClick={this.handleClick} id={l.id} key={i}>
                                                <span className='selection'>
                                                    {this.props.translate ? 
                                                            l.display
                                                             :
                                                            l.id
                                                    }
                                                    {
                                                        this.props.withIcon &&
                                                            <span className={`${l.icon} icon`}></span>
                                                    }
                                                </span>
                                        </li>)}
                                    </ul>
                                )}
                            </div>
                    </span>
            </span>
        )
    }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown.js